import { Package, Truck, Boxes, ScrollText, Factory, Award, Cog } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const categories = [
  { icon: Truck, label: "Pengiriman ke Customer", img: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/zp8od07i_ChatGPT%20Image%20Jul%202%2C%202026%2C%2002_26_37%20PM%20%283%29.png", tall: true },
  { icon: Boxes, label: "Acrylic Sheet Siap Kirim", img: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/kclk40ec_ChatGPT%20Image%20Jul%202%2C%202026%2C%2002_26_37%20PM%20%282%29.png" },
  { icon: Package, label: "Pengemasan Aman", img: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/y9toypl3_ChatGPT%20Image%20Jul%202%2C%202026%2C%2002_26_36%20PM%20%281%29.png" },
  { icon: ScrollText, label: "Loading Pallet Acrylic", img: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/xbf8sshw_ChatGPT%20Image%20Jul%202%2C%202026%2C%2002_26_39%20PM%20%286%29.png", wide: true },
  { icon: Factory, label: "Persiapan Pengiriman", img: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/q3rxkm02_ChatGPT%20Image%20Jul%202%2C%202026%2C%2002_26_38%20PM%20%284%29.png" },
  { icon: Award, label: "Hasil Produk — Plakat Acrylic", img: PHOTOS.produkPlakat },
  { icon: Cog, label: "Proses Produksi Acrylic", img: PHOTOS.produksiRak, wide: true },
];

export const Gallery = () => {
  return (
    <section id="galeri" data-testid="gallery-section" className="py-14 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 sm:gap-6 mb-8 sm:mb-16">
          <div className="max-w-2xl">
            <div className="tag-uppercase text-animax-orange mb-3 sm:mb-4">Portofolio Visual</div>
            <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black">
              Galeri Produk dan Aktivitas
            </h2>
          </div>
          <p className="text-neutral-600 max-w-md text-sm sm:text-base leading-relaxed">
            Dari proses produksi, hasil produk acrylic, hingga pengiriman ke customer —
            lihat aktivitas nyata di balik layar ANIMAX Acrylic.
          </p>
        </div>

        <div className="-mx-5 px-5 sm:mx-0 sm:px-0 flex md:grid md:grid-cols-12 gap-4 md:auto-rows-[220px] overflow-x-auto md:overflow-visible snap-x snap-mandatory pb-2 md:pb-0">
          {categories.map((c, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`
                shrink-0 w-[74vw] md:w-auto snap-start relative rounded-xl md:rounded-2xl overflow-hidden group cursor-pointer aspect-[4/3] md:aspect-auto
                ${c.tall ? "md:col-span-6 md:row-span-2" : c.wide ? "md:col-span-6" : "md:col-span-3"}
              `}
            >
              <img
                src={c.img}
                alt={c.label}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-animax-black/90 via-animax-black/20 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-4 sm:p-5">
                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-animax-yellow flex items-center justify-center mb-3">
                  <c.icon className="w-4 h-4 text-animax-black" />
                </div>
                <div className="font-display text-white text-base md:text-lg font-medium leading-tight">{c.label}</div>
              </div>
              <div className="absolute top-4 right-4 tag-uppercase text-animax-yellow opacity-0 group-hover:opacity-100 transition-opacity">
                0{i + 1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
